define("shared/components/shared/ui/past-post-limit-banner", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _tracking, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div class="cPM--modalBanner--upgrade">
    <div class="u--row">
      <div class="u--col__9">
        {{! Title }}
        <p class="cPM--modalBanner__title">
          {{this.postLimitTitle}}
        </p>
        {{! Text }}
        {{#if this.isMobileSubscription}}
          <p class="cPM--modalBanner__desc">
            {{this.mobileUpgradeText}}
            <Shared::Ui::Button
              @class="u--p__0 u--text--hl"
              @text={{t "shared_phrases.learn_more"}}
              @variant="unstyled"
              onClick={{this.openMobileRedirectModal}}
            />
          </p>
        {{else}}
          <p class="cPM--modalBanner__desc">
            {{this.postLimitDescription}}
          </p>
        {{/if}}
      </div>
      <div class="u--col__3">
        {{#unless this.isMobileSubscription}}
          <Shared::Button::Upgrade
            @feature="getMorePosts"
            @location="post modal -- past post limit"
            @socialProfileType={{@socialProfileType}}
            @text={{this.postLimitButtonText}}
            @variant="outline"
            class={{"cPM--modalBanner__btn--success u--float--right"}}
          />
        {{/unless}}
      </div>
    </div>
  </div>
  */
  {
    "id": "DAAAih34",
    "block": "[[[10,0],[14,0,\"cPM--modalBanner--upgrade\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"u--row\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"u--col__9\"],[12],[1,\"\\n\"],[1,\"      \"],[10,2],[14,0,\"cPM--modalBanner__title\"],[12],[1,\"\\n        \"],[1,[30,0,[\"postLimitTitle\"]]],[1,\"\\n      \"],[13],[1,\"\\n\"],[41,[30,0,[\"isMobileSubscription\"]],[[[1,\"        \"],[10,2],[14,0,\"cPM--modalBanner__desc\"],[12],[1,\"\\n          \"],[1,[30,0,[\"mobileUpgradeText\"]]],[1,\"\\n          \"],[8,[39,1],[[16,\"onClick\",[30,0,[\"openMobileRedirectModal\"]]]],[[\"@class\",\"@text\",\"@variant\"],[\"u--p__0 u--text--hl\",[28,[37,2],[\"shared_phrases.learn_more\"],null],\"unstyled\"]],null],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],[[[1,\"        \"],[10,2],[14,0,\"cPM--modalBanner__desc\"],[12],[1,\"\\n          \"],[1,[30,0,[\"postLimitDescription\"]]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]]],[1,\"    \"],[13],[1,\"\\n    \"],[10,0],[14,0,\"u--col__3\"],[12],[1,\"\\n\"],[41,[51,[30,0,[\"isMobileSubscription\"]]],[[[1,\"        \"],[8,[39,4],[[24,0,\"cPM--modalBanner__btn--success u--float--right\"]],[[\"@feature\",\"@location\",\"@socialProfileType\",\"@text\",\"@variant\"],[\"getMorePosts\",\"post modal -- past post limit\",[30,1],[30,0,[\"postLimitButtonText\"]],\"outline\"]],null],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"@socialProfileType\"],false,[\"if\",\"shared/ui/button\",\"t\",\"unless\",\"shared/button/upgrade\"]]",
    "moduleName": "shared/components/shared/ui/past-post-limit-banner.hbs",
    "isStrictMode": false
  });
  let PastPostLimitBannerComponent = _exports.default = (_dec = (0, _service.inject)('schedule/post'), (_class = class PastPostLimitBannerComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "intl", _descriptor2, this);
      _initializerDefineProperty(this, "subscriptions", _descriptor3, this);
      _initializerDefineProperty(this, "schedulePost", _descriptor4, this);
      _initializerDefineProperty(this, "postLimitDescription", _descriptor5, this);
      this.getPostLimitDescription();
    }
    get isMobileSubscription() {
      return this.subscriptions.isMobileSubscription;
    }
    get mobileUpgradeText() {
      return this.subscriptions.isEligibleForTrial ? this.intl.t('plans.mobile.upgrade.post_limit_trial', {
        platform: this.signupPlatform
      }) : this.intl.t('plans.mobile.upgrade.post_limit', {
        platform: this.signupPlatform
      });
    }
    get signupPlatform() {
      return this.subscriptions.platform;
    }
    get postLimitTitle() {
      return this.schedulePost.getPostLimitTitle(this.args.socialProfileType);
    }
    get postLimitButtonText() {
      return this.auth.currentAccount.canTrialPlan ? this.intl.t('shared_phrases.upgrade_trial') : this.intl.t('shared_phrases.upgrade_plan');
    }
    async getPostLimitDescription() {
      this.postLimitDescription = await this.schedulePost.getPostLimitDescription(this.args.socialProfileType);
    }
    openMobileRedirectModal() {
      this.subscriptions.openMobileRedirectModal();
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "schedulePost", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "postLimitDescription", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return '';
    }
  }), _applyDecoratedDescriptor(_class.prototype, "openMobileRedirectModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "openMobileRedirectModal"), _class.prototype)), _class));
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, PastPostLimitBannerComponent);
});